// ─────────────────────────────────────────────────────────────
// site.js — this deployment's identity, for React code.
//
// Values come from site.config.js by way of scripts/write-site-env.js, which
// the npm scripts run before every start and build. Import SITE instead of
// writing a group's name, domain or town into a component.
//
// Each property is read as a literal process.env.REACT_APP_… expression
// because that is what CRA replaces at build time; a computed lookup like
// process.env[key] is not a pattern to rely on.
// ─────────────────────────────────────────────────────────────

const SITE = Object.freeze({
  name: process.env.REACT_APP_SITE_NAME,
  slug: process.env.REACT_APP_SITE_SLUG,
  domain: process.env.REACT_APP_SITE_DOMAIN,
  url: process.env.REACT_APP_SITE_URL,
  locality: process.env.REACT_APP_SITE_LOCALITY,
  regionCode: process.env.REACT_APP_SITE_REGION_CODE,
  regionName: process.env.REACT_APP_SITE_REGION_NAME,
  prodProjectId: process.env.REACT_APP_SITE_PROD_PROJECT_ID,
  testProjectId: process.env.REACT_APP_SITE_TEST_PROJECT_ID,
  // Consent language. The same strings are reproduced on the generated
  // /opt-in.html that carriers review — see site.config.js.
  smsOptInLabel: process.env.REACT_APP_SITE_SMS_OPT_IN_LABEL,
  smsDisclosure: process.env.REACT_APP_SITE_SMS_DISCLOSURE,
});

// Fail loudly rather than render a privacy policy that names nobody. This
// only trips if react-scripts was run directly, bypassing the npm scripts.
const missing = Object.entries(SITE).filter(([, v]) => !v).map(([k]) => k);
if (missing.length) {
  throw new Error(`Site identity missing (${missing.join(', ')}). ` +
    'Run the build through npm scripts, which call scripts/write-site-env.js.');
}

export default SITE;
